// extracted by mini-css-extract-plugin
export default {"wrapper":"BootstrapWrapper_wrapper__wtOhw"};